import { InputAdornment } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';

export const InputAdornmentCheck = () => (
  <InputAdornment position="start">
    <CheckCircle color="secondary" />
  </InputAdornment>
);
